<template>
  <div class="interval-data-card column-flex card">
    <!--    tab切换-->

    <div class="flex-0 flex items-center tabs">
      <Dropdown
        v-if="zoneTabs.length"
        :options="tabKeys"
      >
        <Button>
          {{ tabNames[tabKeys.indexOf(activeTab)] }}
          <IconDown class="ml-5" />
        </Button>
        <template #content>
          <Dropdown.Option
            v-for="item in tabKeys"
            :key="item"
            @click="changeActiveTabItem(item)"
          >
            {{ tabNames[tabKeys.indexOf(item)] }}
          </Dropdown.Option>
        </template>
      </Dropdown>
    </div>
    <div class="flex-1">
      <div class="column-flex tab-content">
        <div
          v-for="(item, index) in intervalData"
          :key="'row-' + index"
          class="flex items-center row"
        >
          <div
            class="progress-bar"
            :style="{
              width: item.proportion,
              'background-color': item.color
            }"
          ></div>
          <div class="flex-1 flex row-content">
            <div
              class="column"
              :title="item.name"
            >
              <span class="ow-h2">{{ item.name }}</span>
            </div>
            <div
              class="column"
              :title="item.range"
            >
              <span class="ow-h2">{{ item.range }}</span>
            </div>
            <div
              class="column"
              :title="item.value"
            >
              <span class="ow-h2">{{ item.value }}</span>
            </div>
            <div
              class="column"
              :title="item.proportion"
            >
              <span class="ow-h2">{{ item.proportion }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { ButtonGroup, Button, Dropdown } from '@arco-design/web-vue';
import { onMounted } from 'vue';
import { useZoneData } from '../../hooks/useZoneData';
import type { ZoneTabItem } from '../../hooks/useZoneData/types';
import { IconDown } from '@arco-design/web-vue/es/icon';

const { intervalData, processIntervalData, zoneTabs } = useZoneData();
const activeTab = ref<ZoneTabItem['key']>('Pace Zone');
const tabKeys = ref<ZoneTabItem['key'][]>([]);
const tabNames = ref<ZoneTabItem['text'][]>([]);

const init = () => {
  if (zoneTabs.value?.length) {
    tabKeys.value = zoneTabs.value.map((item) => item.key);
    tabNames.value = zoneTabs.value.map((item) => item.text);

    if (tabKeys.value.includes('Pace Zone')) {
      activeTab.value = 'Pace Zone';
    } else {
      activeTab.value = 'HR Zone';
    }
    processIntervalData(activeTab.value);
  }
};

onMounted(() => {
  init();
});
watch(zoneTabs, init);
// 变更活动子项
function changeActiveTabItem(key: ZoneTabItem['key']) {
  activeTab.value = key;
  processIntervalData(activeTab.value);
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  .tabs {
    margin: 12px;
    box-sizing: border-box;

    .tab-item {
      &.active {
        border: solid 1px rgba(255, 255, 255, 0.05);
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .tab-content {
    width: 100%;

    .row {
      position: relative;
      margin-bottom: 8px;
      height: 40px;

      //&:nth-last-of-type(1) {
      //  margin-bottom: 0;
      //}

      .progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        transition: width 0.3s linear;
        opacity: 0.2;
        z-index: 0;
      }

      .row-content {
        position: relative;
        width: 100%;
        .column {
          flex-grow: 0;
          flex-shrink: 0;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          font-size: 14px;
          overflow: hidden;

          &:nth-of-type(1) {
            width: 30%;
            color: rgba(255, 255, 255, 1);
            text-align: center;
          }
          &:nth-of-type(2) {
            width: 30%;
            color: rgba(255, 255, 255, 0.6);
          }
          &:nth-of-type(3) {
            width: 20%;
            color: rgba(255, 255, 255, 0.6);
          }
          &:nth-of-type(4) {
            width: 20%;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
}
</style>
